<div class="profile-container">
    <div class="">
        <div class="profile-content">
            <button class="add-b" data-toggle="modal" data-target="#addMarket" (click)="addButton()">Add</button>
            <div class="personal-details">
                <h4 class="personal-details-title">Marketing List</h4>
                <table class="table table-striped">
                    <thead>
                        <tr>
                        <th scope="col">#</th>
                        <th scope="col">Name</th>
                        <th scope="col">Phone</th>
                        <th scope="col">Last Modified On</th>
                        <th scope="col">Status</th>
                        <th scope="col">Created On</th>
                        <th scope="col">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let data of marketingData | paginate : {
                            itemsPerPage: tableSize,
                            currentPage: page,
                            totalItems: count
                          } ;let i = index">
                        <th scope="col">{{i+1}}</th>
                        <th scope="col">{{data.name}}</th>
                        <th scope="col">{{data.phone}}</th>
                        <th scope="col">{{data.latestStatusDate|date : 'medium'}}</th>
                        <th scope="col">{{data.latestStatus}}</th>
                        <th scope="col">{{data.createdDate | date : 'medium'}}</th>

                        <th scope="col">
                            <i class="bi bi-pencil-square" (click)="getMarketingDataById(data.marketingDataId)" data-toggle="modal" data-target="#updateModal"></i>
                            <i class="bi bi-eye-fill" data-toggle="modal" data-target="#view" (click)="getMarketingDataById(data.marketingDataId)"></i>
                        </th>
                        </tr>
                    </tbody>
                </table>
                <div class="pagination-block" *ngIf="marketingData.length != 0">
                    <pagination-controls
                      previousLabel="Prev"
                      nextLabel="Next"
                      (pageChange)="onTableDataChange($event)">
                    </pagination-controls>
                  </div>
            </div>
        </div>
    </div>
</div>


<div class="modal fade" id="addMarket" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Add Marketing Data
                    <span data-dismiss="modal">
                        <svg data-dismiss="modal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
                        </svg>
                    </span>
                </h5>
            </div>
            <div class="modal-body">
                <div [formGroup]="marketingForm">
                    <div class="form-group">
                        <div class="row">
                            <div class="col-md-6 col-lg-6">
                                <label>Name <span class="required-field">*</span></label>
                                <input formControlName="name" type="text" class="form-control">
                                <span class="err" *ngIf="marketingForm.get('name').invalid && marketingFormSubmit">name required</span>
                            </div>
                            <div class="col-md-6 col-lg-6">
                                <label>Phone <span class="required-field">*</span></label>
                                <input formControlName="phone" type="number" class="form-control">
                                <span class="err" *ngIf="marketingForm.get('phone').invalid && marketingFormSubmit">user mobile required and should be 10 digits</span>
                            </div>
                            <div class="col-md-6 col-lg-6">
                                <label>Email <span class="required-field">*</span></label>
                                <input formControlName="email" type="email" class="form-control">
                                <span class="err" *ngIf="marketingForm.get('email').errors?.required && marketingFormSubmit">user email required</span>
                                <span class="err" *ngIf="marketingForm.get('email').errors?.pattern && marketingFormSubmit">valid user email required</span>
                            </div>
                            <div formArrayName="keyValueList">
                                <div *ngFor="let param of marketingForm.controls.keyValueList['controls'];let i = index;let last = last" [formGroupName]="i">
                                    <div class="col-md-6 col-lg-6">
                                        <label>{{TypeData[i].name}}</label>
                                        <input *ngIf="TypeData[i].possibleValue.length == 0" formControlName="value" placeholder="enter param value" type="text" class="form-control">
                                        <select class="form-control" *ngIf="TypeData[i].possibleValue.length != 0" formControlName="value">
                                            <option value="" disabled selected hidden>---select value---</option>
                                            <option *ngFor="let param of TypeData[i].possibleValue" [value]="param">{{param}}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-6 col-lg-6">
                                <div class="form-group">
                                  <label>Assign To</label>
                                  <select class="form-control" formControlName="assignedToUser">
                                    <option *ngFor="let user of usersList" [value]="user.userId">{{user.userName}}</option>
                                  </select>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-6">
                                <div class="form-group ">
                                    <label>Tag Users</label>
                                    <ng-multiselect-dropdown
                                    [placeholder]="'tag users'" [ngModelOptions]="{standalone: true}"
                                    [settings]="tagUsersdropdownSettings"
                                    [data]="tagUsersdropdownList"
                                    [(ngModel)]="tagUsersselectedItems"
                                    class="form-control"
                                    style="padding: 0;border: none"
                                    (onSelect)="onItemSelect($event)"
                                    (onSelectAll)="onSelectAll($event)"
                                    >
                                    </ng-multiselect-dropdown>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" id="closeModalButton2"   class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                    <button type="button" (click)="addMarketingData()" class="btn btn-primary">Add</button>
                </div>
            </div>
        </div>
    </div>
</div>


<!-- <button data-toggle="modal" data-target="#view" id="template-view" style="display:none"></button> -->

<div class="modal fade" id="view" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title status-b" id="exampleModalLabel">Marketing Data List  <span><button class="btn btn-primary">{{latestStatus}}</button><i class="bi bi-x-square" data-dismiss="modal"></i></span> </h5>
            </div>
            <div class="modal-body">
                <div class="form-group" *ngFor="let data of singleMarketingData">
                    <div class="row">
                        <div class="col-md-6 col-lg-6">
                            <label>Name</label>
                            <input type="text" readonly value="{{data.name}}" class="form-control">
                        </div>
                        <div class="col-md-6 col-lg-6">
                            <label>Phone</label>
                            <input type="text" readonly value="{{data.phone}}" class="form-control">
                        </div>
                    
                        <div class="col-md-6 col-lg-6">
                            <label>Email</label>
                            <input type="text" readonly value="{{data.email}}" class="form-control">
                        </div>
                        <div class="col-md-6 col-lg-6" *ngFor="let keyValueList of data.keyValueList">
                            <label for="">{{keyValueList.key}}</label>
                            <input type="text" readonly value="{{keyValueList.value}}" class="form-control">
                        </div>
                    </div>
                    <!-- <div class="row update-status" *ngIf="toggleStatus" [formGroup]="updateMarketingForm">
                        <div class="col-md-12 col-lg-12">
                            <div class="form-group">
                              <select name="" id="" formControlName="status" class="form-control">
                                <option value="" disabled selected hidden>---Select Status---</option>
                                <option value="{{status.name}}" *ngFor="let status of statusList">{{status.name}}</option>
                              </select>
                            </div>
                          </div>
                        <div class="col-md-12 col-lg-12">
                            <textarea name="" id="" cols="30" rows="5" formControlName="note" class="form-control" placeholder="enter note"></textarea>
                        </div>
                        <div class="col-md-12 col-lg-12">
                            <button class="btn btn-secondary" (click)="updateStatus()">update status</button>
                        </div>
                    </div> -->
                    <div class="row key">
                        <div class="keys">
                            <div class="col-md-12 col-lg-12">
                                <div class="status-table">
                                    <table class="table">
                                        <thead>
                                          <tr>
                                              <th style="width: 10%;">User Id</th>
                                              <th style="width: 45%;text-align: center;">Note</th>
                                              <th style="width: 15%;text-align: center;">Status</th>
                                              <th style="width: 30%;text-align: center;">Modified</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr *ngFor="let status of data.marketingStatusList;">
                                              <td style="width: 10%;">{{status.userId}}</td>
                                              <td style="width: 45%;text-align: center;">{{status.note}}</td>
                                              <td style="width: 15%;text-align: center;">{{status.status}}</td>
                                              <td style="width: 30%;text-align: center;">{{status.statusDate | date : 'medium'}}</td>
                                          </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                     
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" id="closeModalButton2"  class="btn btn-secondary" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="updateModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title status-b" id="exampleModalLabel">Marketing Data Edit  <span><button class="btn btn-primary" data-toggle="modal" data-target="#statusUpdatrPopup" (click)="showStatus()">{{latestStatus}}</button><i class="bi bi-x-square" data-dismiss="modal"></i></span> </h5>
            </div>
            <div class="modal-body" style="padding-right: 0;">
                <div class="form-group" style="height: 480px;overflow-y: scroll;padding-right: 15px;overflow-x: hidden;" *ngFor="let data of singleMarketingData;let i = index">
                    <div class="row">
                        <div class="col-md-6 col-lg-6">
                            <label>Name</label>
                            <input type="text" [(ngModel)]="singleMarketingData[i].name" class="form-control">
                        </div>
                        <div class="col-md-6 col-lg-6">
                            <label>Phone</label>
                            <input type="text" [(ngModel)]="singleMarketingData[i].phone" class="form-control">
                        </div>
                    
                        <div class="col-md-6 col-lg-6">
                            <label>Email</label>
                            <input type="text" [(ngModel)]="singleMarketingData[i].email" class="form-control">
                        </div>
                        <div class="col-md-6 col-lg-6" *ngFor="let keyValueList of data.keyValueList;let j = index">
                            <label for="">{{keyValueList.key}}</label>
                            <input type="text" [(ngModel)]="singleMarketingData[i].keyValueList[j].value" class="form-control">
                        </div>
                    </div>
                    <!-- <div class="row update-status" *ngIf="toggleStatus" [formGroup]="updateMarketingStatus">
                        <div class="col-md-12 col-lg-12">
                            <div class="form-group">
                              <select name="" id="" formControlName="status" class="form-control">
                                <option value="" disabled selected hidden>---Select Status---</option>
                                <option value="{{status.name}}" *ngFor="let status of statusList">{{status.name}}</option>
                              </select>
                            </div>
                          </div>
                        <div class="col-md-12 col-lg-12">
                            <textarea name="" id="" cols="30" rows="5" formControlName="note" class="form-control" placeholder="enter note"></textarea>
                        </div>
                        <div class="col-md-12 col-lg-12">
                            <button class="btn btn-secondary" (click)="updateStatus()">update status</button>
                            <button class="btn btn-secondary" style="margin-left: 10px" (click)="updateStatusClose()">cancel</button>
                        </div>
                    </div> -->

                    <div class="row key">
                        <div class="keys">
                            <div class="col-md-12 col-lg-12">
                                <div class="status-table">
                                    <table class="table">
                                      <thead>
                                        <tr>
                                            <th style="width: 10%;">User Id</th>
                                            <th style="width: 45%;text-align: center;">Note</th>
                                            <th style="width: 15%;text-align: center;">Status</th>
                                            <th style="width: 30%;text-align: center;">Modified</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr *ngFor="let status of data.marketingStatusList;">
                                            <td style="width: 10%;">{{status.userId}}</td>
                                            <td style="width: 45%;text-align: center;">{{status.note}}</td>
                                            <td style="width: 15%;text-align: center;">{{status.status}}</td>
                                            <td style="width: 30%;text-align: center;">{{status.statusDate | date : 'medium'}}</td>
                                        </tr>
                                      </tbody>
                                    </table>
                                </div>
                            </div>

                     
                        </div>
                    </div>
                
                </div>
                <div class="modal-footer">
                    <button type="button" id="closeModalButton2"  class="btn btn-secondary" data-dismiss="modal">Close</button>
                    <button type="button" (click)="updateMarketingData()" class="btn btn-primary">Update</button>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="modal fade" id="statusUpdatrPopup" tabindex="-1" data-backdrop="static" aria-labelledby="statusUpdatrPopup" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Update Status</h5>
        </div>
        <div class="modal-body">
            <div class="row update-status" *ngIf="toggleStatus" [formGroup]="updateMarketingStatus">
                <div class="col-md-12 col-lg-12">
                    <div class="form-group">
                        <select name="" id="" formControlName="status" class="form-control">
                            <option value="" disabled selected hidden>---Select Status---</option>
                            <option value="{{status.name}}" *ngFor="let status of statusList">{{status.name}}</option>
                        </select>
                    </div>
                    <span class="err" *ngIf="updateMarketingStatus.get('status').invalid && updateMarketingStatusSubmit">status required</span>
                </div>
                <div class="col-md-12 col-lg-12">
                    <textarea name="" id="" cols="30" rows="5" formControlName="note" class="form-control" placeholder="enter note"></textarea>
                    <span class="err" *ngIf="updateMarketingStatus.get('note').invalid && updateMarketingStatusSubmit">note required</span>
                </div>
            </div>
     
            <div class="modal-footer">
                <button class="btn btn-secondary" (click)="updateStatus()">update status</button>
                <button type="button" id="closeModalButton67"   class="btn btn-secondary" (click)="updateStatusClose()" data-dismiss="modal">Cancel</button>
            </div>
        </div>
      </div>
    </div>
</div>